import { _getGrowthBookInstance } from './getGrowthBookInstance';

/**
 * Resolves a GrowthBook feature flag value for the current user. Shared by
 * extension capabilities that need host-side flag resolution (e.g. the
 * feature-flag capability and the sidebar-menu-control `featureFlag` gate).
 *
 * @returns the flag value as `unknown`. The concrete type depends on how the
 * flag is configured in GrowthBook (`evalFeature().value` is `T | null` with
 * `T = any`), so it can be a boolean, string, number, or JSON. The sidebar gate
 * only reads it for truthiness, while the feature-flag capability forwards the
 * raw value to extensions, so callers must coerce as needed.
 */
export const resolveGrowthBookFeature = async (
  feature: string,
): Promise<unknown> => {
  const growthBookInstance = await _getGrowthBookInstance();
  return growthBookInstance.evalFeature(feature).value;
};
